export default {
  items: [
    {
    
      name: 'Home',
      url: '/home',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
    
      name: 'About Us',
      url: '/aboutus',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      title: true,
      name: 'Video',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
     {
    
      name: 'Video 1',
      url: '/video',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
    
      name: 'Video 2',
      url: '/video1',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
    
      name: 'Video 3',
      url: '/video2',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      title: true,
      name: 'Products',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Rotating Unions',
      url: '/rotating',
      icon: 'icon-puzzle',
     
      children: [
        {
          name: 'Water & Hot Oil 250F',
          url: '/products/1',
          icon: 'icon-puzzle'
        },
        {
          name: 'Water & Hot Oil 450F',
          url: '/products/2',
          icon: 'icon-puzzle'
        },
        {
          name: 'Air & Hydraulic',
          url: '/products/3',
          icon: 'icon-puzzle'
        },
        {
          name: 'Collant',
          url: '/products/4',
          icon: 'icon-puzzle'
        },
        {
          name: 'Special Application',
          url: '/products/5',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      divider: true
    },
    {
      name: 'Slip Ring Unions',
      url: '/slipring',
      icon: 'icon-cursor',
      children: [
        {
          name: 'Slip Rings',
          url: '/products/6',
          icon: 'icon-cursor'
        },
     
      ]
    },
    {
      name: 'Barco',
      url: '/barco',
      icon: 'icon-cursor',
      children: [
        {
          name: 'Barco',
          url: '/products/7',
          icon: 'icon-cursor'
        },
     
      ]
    },
    {
      divider: true
    },
   
 
  ]
}
